export default __webpack_public_path__ + "static/media/flag-kyrgyzstan.6ecbcdc3.svg";